export enum IntakeFormReservedFieldNames {
	FullName = 'reserved_fullname',
	Email = 'reserved_email',
	PhoneNumber = 'reserved_phone'
}
